import { useIsFeatureEnabled } from "src/global/hooks/useIsFeatureEnabled.ts"

export function useIsGXAgentEnabled() {
  const hasOwnAgent = useIsFeatureEnabled("forceEnableAgent")

  return hasOwnAgent
}
